import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { TownNodeConnection, TownNodeEdge } from '../../../schema';
import { townDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class TownDropdown extends React.Component<Props, {}> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);
  }

  fetch = (name: string) =>
    new Promise<TownNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string, selectedState: string }, { data: { allTowns: TownNodeConnection } }>(
        API_URL,
        { name, selectedState: this.props.selectedState },
        townDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allTowns.edges),
        (e) => reject(e),
      );
    })

  render() {
    return (
      this.props.selectedState && <AutoCompleteAsync
        {...this.props}
        mode='single'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<TownNodeEdge>, 'data'> {
  selectedState: string;
  mode: 'single';
  value: TownNodeEdge;
  onChange: (value: TownNodeEdge) => void;
}
